import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
    id: number;
    message: string;
    type: ToastType;
    duration: number;
}

interface ToastState {
    toasts: Toast[];
    add: (opts: { message: string; type?: ToastType; duration?: number }) => void;
    remove: (id: number) => void;
}

let nextId = 0;

export const useToastStore = create<ToastState>((set) => ({
    toasts: [],
    add: ({ message, type = 'info', duration = 3000 }) =>
        set((state) => ({
            toasts: [...state.toasts, { id: nextId++, message, type, duration }],
        })),
    remove: (id) =>
        set((state) => ({
            toasts: state.toasts.filter((t) => t.id !== id),
        })),
}));
